import { apiClient } from '@/api/client';
import type { PublicPage } from '@/lib/types/public-pages';

/**
 * Public page content read (MYN-197, MYN-198). `@Public()` on the backend -
 * reachable with or without a session. `/v1` is supplied by `API_BASE_URL`,
 * so the path below is version-free.
 *
 * Rejects (propagates, never swallows) on a 404 - an unpublished or unknown
 * slug - so the caller can render its own not-available state rather than a
 * partial page.
 */
export async function fetchPublicPage(slug: string): Promise<PublicPage> {
  const res = await apiClient.get<PublicPage>(`/pages/${slug}`);
  return res.data;
}
